import {Component, Inject, OnInit, ViewChild} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MaterialModule} from "../../../app-material.module";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {HttpService} from "../../../services/http/http.service";
import {CommonsService} from "../../../services/commons/commons.service";
import {DetailProfiloDialog} from "../detail-profilo/detail-profilo.component";

@Component({
  selector: 'detail-competenza-component',
  templateUrl: './detail-competenza.component.html',
  styleUrls: ['./detail-competenza.component.scss']
})
export class DetailCompetenzaDialog implements OnInit {
  displayedColumns: string[] = ['nomeProfilo', 'descrizioneArea.descrizione'];
  dataSource = new MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  title: string;
  datiCompetenza : any;
  classificazioniAda: any;
  classificazioniIstat: any;
  classificazioniAteco: any;
  classificazioniIsco: any;
  elencoProfili: any;
  paginatorSize: any;
  listaAbilita: any;
  listaConoscenze: any;
  constructor(
    public dialogRef: MatDialogRef<DetailProfiloDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: HttpService,
    private commons: CommonsService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.title = this.data.title;

    this.commons.getCompetenzaDettaglio(this.data.id).subscribe({
      next: (response: any) => {
        this.datiCompetenza = response.result;
      }
    })

    this.commons.getCodiciAdaByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAda = response.result;
      }
    })

    this.commons.getCodiciIstatByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIstat = response.result;
      }
    })

    this.commons.getCodiciAtecoByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniAteco = response.result;
      }
    })

    this.commons.getCodiciIscoByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.classificazioniIsco = response.result;
      }
    })

    this.commons.getAbilitaByCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.listaAbilita = response.result;
      }
    })

    this.commons.getConoscenzeByCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.listaConoscenze = response.result;
      }
    })

    this.commons.getProfiliProfessionaliByIdCompetenza(this.data.id).subscribe({
      next: (response: any) => {
        this.elencoProfili = response.result;
        this.paginatorSize = response.result.count;
        this.dataSource = this.elencoProfili;
        this.dataSource.paginator = this.paginator;
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
